import {
  addDays,
  eachDayOfInterval,
  getDay,
  getHours,
  getMinutes,
  lastDayOfMonth,
  setHours,
  setMinutes,
  subDays
} from 'date-fns'
import addMonths from 'date-fns/addMonths'
import addWeeks from 'date-fns/addWeeks'
import endOfDay from 'date-fns/endOfDay'
import endOfMonth from 'date-fns/endOfMonth'
import endOfWeek from 'date-fns/endOfWeek'
import format from 'date-fns/format'
import startOfDay from 'date-fns/startOfDay'
import startOfMonth from 'date-fns/startOfMonth'
import startOfWeek from 'date-fns/startOfWeek'
import _, { toString } from 'lodash'
import moment from 'moment'
import { WEEK_DAYS, WEEK_DAYS_SUNDAY_FIRST } from './constant'

export function currentMomentWithTimezone (timezone = 7) {
  const date = new Date()
  const dateValue = date.getTime()
  const dateWithTimezone =
    dateValue + date.getTimezoneOffset() * 60 * 1000 + timezone * 60 * 60 * 1000
  return moment(dateWithTimezone)
}

export function getNextWeekWithTimzone (index) {
  const current = currentDateWithTimezone()
  const date = addWeeks(current, index)
  const startDay = startOfWeek(date, { weekStartsOn: 1 })
  const endDay = endOfWeek(date, { weekStartsOn: 1 })
  return { startDay, endDay }
}

export function getNextMonthWithTimezone (index) {
  const current = currentDateWithTimezone()
  const date = addMonths(current, index)
  const startDay = startOfMonth(date)
  const endDay = endOfMonth(date)
  return { startDay, endDay }
}

export function currentDateWithTimezone (timezone = 7) {
  const date = new Date()
  const dateValue = date.getTime()
  const timeStampWithTimezone =
    dateValue + date.getTimezoneOffset() * 60 * 1000 + timezone * 60 * 60 * 1000
  return new Date(timeStampWithTimezone)
}

export function currentDateWithTimezoneV2 (dateStart, timezone = 7) {
  const date = new Date(dateStart)
  const dateValue = date.getTime()
  const timeStampWithTimezone =
    dateValue + date.getTimezoneOffset() * 60 * 1000 + timezone * 60 * 60 * 1000
  return new Date(timeStampWithTimezone)
}

export function startAndEndOfDayTimestampWithTimeZone (timestamp, timezone = 7) {
  const clientOffset = new Date().getTimezoneOffset() * 60 * 1000
  const targetTimezoneOffset = -timezone * 60 * 60 * 1000
  const difference = targetTimezoneOffset - clientOffset
  return {
    targetStartTimestamp: startOfDay(timestamp).getTime() + difference,
    targetEndTimestamp: endOfDay(timestamp).getTime() + difference
  }
}

/**
 * Thêm số 0 như là prefix nếu n < 10
 * @param {Number} n
 * @returns {String}
 * VD:
 * 8 --> 08.
 * 11 --> 11.
 */
export const additionalZero = (n) => {
  return n && n > 0 ? (n < 10 ? `0${n}` : n) : '00'
}

/**
 * Đổi date từ data backend trả về sang Date String có dạng dd/MM/yyyy
 * @param {Number} date - Lấy từ data backend server trả về có dạng: YYYYmmdd. VD: 20221225 (25/12/2022)
 * @returns {String} - Date được trả về dưới dạng dd/MM/yyyy. VD: 25/12/2022
 */
export const formatNumberDdMMyyyy = (date) => {
  return date ? format(convertNumberToDate(date), 'dd/MM/yyyy') : ''
}

/**
 * Đổi date từ data backend trả về sang Date Object
 * @param {Number} num - Lấy từ data backend server trả về có dạng: YYYYmmdd. VD: 20221225 (25/12/2022)
 * @returns {Object} - Return về Date Object
 */
export function convertNumberToDate (num) {
  if (!num || num <= 0) {
    return 0
  }
  const day = num % 100
  const month = ((num - day) / 100) % 100
  const year = (num - day - 100 * month) / 10000
  return new Date(year, month - 1, day)
}

/**
 *
 * @param {Object} param0
 * @param {Number} param0.date - Lấy từ data backend server trả về có dạng: YYYYmmdd. VD: 20221225 (25/12/2022)
 * @param {Number} param0.startTime - là thời gian trong ngày hệ quy đổi phút. Ví dụ: startTime = 610 nghĩa là 10 giờ 10 phút sáng
 * @returns ??????????????????????????
 */
export const dateNumberAndStartTimeToDate = ({ date, startTime }) => {
  let dateType = convertNumberToDate(date)
  const { hours, minutes } = timeConvert(startTime)
  dateType = setHours(dateType, hours)
  dateType = setMinutes(dateType, minutes)
  return dateType
}

/**
 *
 * @param {Number} time - là thời gian trong ngày hệ quy đổi phút. Ví dụ: time = 610 nghĩa là 10 giờ 10 phút sáng
 * @returns {String}
 * - Giá trị trả về có dạng: HH:mm. Ví dụ: 09:45
 */
export const timeConvertHHmm = (time) => {
  const { hours, minutes } = timeConvert(time)
  return additionalZero(hours) + ':' + additionalZero(minutes)
}

/**
 *
 * @param {Number} time - là thời gian trong ngày hệ quy đổi phút. Ví dụ: time = 610 là: 10 giờ 10 phút sáng
 * @returns {Object}
 * - Giá trị trả về có dạng: { hours: Number, minutes: Number }
 */
export const timeConvert = (time) => {
  if (!time) return { hours: 0, minutes: 0 }
  return { hours: Math.floor(time / 60), minutes: time % 60 }
}

/**
 * Đổi Date Object thành Date String
 * @param {Object} date - Date object
 * @returns {String} - Ngày trả về được format dạng: YYYYmmdd . VD: 20221225 (25/12/2022)
 */
export const convertDateToNumber = (date) => {
  return format(date, 'yyyyMMdd')
}

/**
 * Lấy ngày-tháng-năm thời điểm hiện tại
 * @returns {String} - Ngày trả về được format dạng: YYYYmmdd . VD: 20221225 (25/12/2022)
 */
export const currentDateNumber = () => convertDateToNumber(new Date())

/**
 *
 * @param {Object[]} rangeTimesList
 * @param {String} rangeTimesList[].id
 * @param {Number} rangeTimesList[].startTime - Thời gian trong ngày của hệ quy đổi phút. Ví dụ: 610 là 10 giờ 10 phút sáng
 * @param {Number} rangeTimesList[].endTime - Thời gian trong ngày của hệ quy đổi phút. Ví dụ: 680 là 11 giờ 20 phút sáng
 * @param {Object} options
 * @param {String} options.optionLabelFormat - Nhận template với 2 key: START, END là key chính. Ví dụ: START_END, START-END. Default: 'START'
 * @param {String} options.optionValueByKey - Key của phần tử trong mảng rangeTimesList được sử dụng làm value của option. Default: 'id'
 * @returns {Array}
 * - Array trả về sẽ là mảng có cấu trúc như sau: [{ value: String | Number, id: Number, label: String }]
 */
export function createRangeTimeOptions (rangeTimesList, options = {
  optionLabelFormat: 'START',
  optionValueByKey: 'id'
}) {
  if (!rangeTimesList || !rangeTimesList.length) return []
  const { optionLabelFormat, optionValueByKey } = options
  return rangeTimesList.map(time => ({
    value: time[optionValueByKey],
    id: time.id,
    label: optionLabelFormat.replace('START', timeConvertHHmm(time.startTime)).replace('END', timeConvertHHmm(time.endTime))
  }))
}

// TODO: Tuấn Anh check lại xem có cần clone không, đang trùng chức năng với function createRangeTimeOptions
export function createRangeTimeTable (rangeTimesList, options = {
  optionLabelFormat: 'START',
  optionValueByKey: 'classTimeSlotId'
}) {
  if (!rangeTimesList || !rangeTimesList.length) return []
  const { optionLabelFormat, optionValueByKey } = options
  return rangeTimesList.map(time => ({
    value: time[optionValueByKey],
    label: optionLabelFormat.replace('START', timeConvertHHmm(time.startTime)).replace('END', timeConvertHHmm(time.endTime))
  }))
}

export const numberMoment = (dateNumber) => {
  return !_.isNil(dateNumber) && String(dateNumber).length === 8
    ? moment(convertNumberToDate(dateNumber).toISOString())
    : undefined
}

export function convertDateToTutorDate (date) {
  return Number(format(date, 'yyyyMMdd'))
}

export const getStartDateAndEndDate = (timezone = 7) => {
  const startDate = new Date()
  const endDate = addDays(startDate, 6)
  const startDateWithTimeZone = startDate.getTime() + startDate.getTimezoneOffset() * 60 * 1000 + timezone * 60 * 60 * 1000
  const endDateWithTimeZone = endDate.getTime() + endDate.getTimezoneOffset() * 60 * 1000 + timezone * 60 * 60 * 1000

  return { startDate: moment(startDateWithTimeZone), endDate: moment(endDateWithTimeZone) }
}
export const getEndDateEqualCurrentDate = (timezone = 7) => {
  const endDate = new Date()
  const startDate = subDays(endDate, 6)
  const startDateWithTimeZone = startDate.getTime() + startDate.getTimezoneOffset() * 60 * 1000 + timezone * 60 * 60 * 1000
  const endDateWithTimeZone = endDate.getTime() + endDate.getTimezoneOffset() * 60 * 1000 + timezone * 60 * 60 * 1000

  return { startDate: moment(startDateWithTimeZone), endDate: moment(endDateWithTimeZone) }
}

export const getLstDaysByDayInMonth = (month, day, isManager) => {
  const rs = []

  const dayIdx = WEEK_DAYS_SUNDAY_FIRST.findIndex(x => x === day)

  const startMonth = month
  const endMonth = lastDayOfMonth(month)

  const lstDayInMonth = eachDayOfInterval({ start: startMonth, end: endMonth })

  for (let index = 0; index < lstDayInMonth.length; index++) {
    const element = lstDayInMonth[index]
    const dayElement = getDay(element)
    if (dayElement === dayIdx) {
      rs.push(convertDateToNumber(element))
    }
  }
  return rs
}
export const getDateByDayInWeek = (week, day) => {
  const dayIdx = WEEK_DAYS.findIndex(x => x === day)
  const dateReturn = addDays(week, dayIdx)

  return convertDateToNumber(dateReturn)
}

/**
 * Lấy giờ giấc hiện tại hệ quy đổi phút.
 * @returns {Number}
 * VD: Hiện tại là 9h30 sáng --> 570
 */
export const getTimeNumberCurrent = () => {
  const current = new Date()
  const hours = getHours(current)
  const minutes = getMinutes(current)
  return (hours * 60) + minutes
}

export const dateNumberAndHourMinuteToDate = (param) => {
  let dateType = new Date()
  if (param?.date) {
    dateType = convertNumberToDate(param.date)
  }
  dateType = setHours(dateType, param?.hour || 0)
  dateType = setMinutes(dateType, param?.minute || 0)
  return dateType
}

/**
 * Lấy date từ backend trả về dạng YYYYmmdd
 * @returns {String} - Ngày trả về được format dạng: YYYY-mm-dd . VD: 2023-03-17 (17/03/2023)
 */
export const formatDateToStrikethrough = (date) => {
  const dateString = toString(date)
  const year = dateString.slice(0, 4)
  const month = dateString.slice(4, 6)
  const day = dateString.slice(6)
  return `${year}-${month}-${day}`
}

/**
 *
 * @param {Number} value - day value return of moment
 * @returns
 */
export function getDayOfWeekString (value) {
  switch (value) {
    case 0:
      return 'SUNDAY'
    case 1:
      return 'MONDAY'
    case 2:
      return 'TUESDAY'
    case 3:
      return 'WEDNESDAY'
    case 4:
      return 'THURSDAY'
    case 5:
      return 'FRIDAY'
    case 6:
      return 'SATURDAY'
  }
}

/**
 *
 * @param {Number} date - định dạnh yyyymmdd
 * @returns {String} - trả về ngày trong tuần vd: MONDAY
 */
export function getWeekDayOfTheDate (date) {
  return getDayOfWeekString(new Date(formatDateToStrikethrough(date)).getDay())
}

/**
 *
 * @returns {Number} - trả về timestamp miliseconds
 */
export function getCurrentTimeLong () {
  return moment().valueOf()
}

/**
 *
 * @returns {Number} - trả về HH:mm:ss DD/MM/YYYY
 */
export function getCurrentTime () {
  return moment().format('HH:mm:ss DD/MM/YYYY')
}

/**
 * @param {Number} time - định dạnh hh:mm
 * @returns {Number} - trả về sô vd 500
 */

export function getTimeNumber (time) {
  if (!time) return null
  const timeConvert = time.split(':')
  return Number(timeConvert[0] * 60) + Number(timeConvert[1])
}

export function getStartAndEndDateOfWeek (week, year) {
  // Tạo một đối tượng Date với ngày đầu tiên của năm
  const date = new Date(year, 0, 1)

  // Thêm số ngày (7 * tuần) vào ngày đầu tiên của năm để đến tuần mong muốn
  date.setDate(date.getDate() + (week - 1) * 7)

  // Tìm ngày bắt đầu của tuần (thứ 2)
  const startOfWeek = new Date(date.setDate(date.getDate() - date.getDay() + 1))

  // Tìm ngày kết thúc của tuần (chủ nhật)
  const endOfWeek = new Date(date.setDate(date.getDate() + 6))

  return { startOfWeek, endOfWeek }
}

export function getWeekOptions (year) {
  const options = []
  const dateOption = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }
  const locale = 'vi-VN'
  for (let week = 1; week <= 52; week++) {
    const { startOfWeek, endOfWeek } = getStartAndEndDateOfWeek(week, year)
    const label = `${startOfWeek.toLocaleDateString(
      locale,
      dateOption
    )} - ${endOfWeek.toLocaleDateString(locale, dateOption)}`
    options.push({
      value: `${convertDateToTutorDate(startOfWeek)}-${convertDateToTutorDate(
        endOfWeek
      )}`,
      label,
      week: week,
      startDate: convertDateToTutorDate(startOfWeek)
    })
  }
  return options
}

export function getWeekNumberOptions (year) {
  const weeksInYear = getWeeksInYear(year)
  const weekNumberOptions = []

  for (let week = 1; week <= weeksInYear; week++) {
    weekNumberOptions.push({ value: week, label: `Week ${week}` })
  }

  return weekNumberOptions
}

function getWeeksInYear (year) {
  const lastDayOfYear = new Date(year, 11, 31)
  return getWeekNumber(lastDayOfYear)
}

export function getWeekNumber (date) {
  const firstDayOfYear = new Date(date.getFullYear(), 0, 1)
  const pastDaysOfYear = (date - firstDayOfYear) / 86400000
  return Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7)
}

export function getWeekNumberByDateInt (dateInt) {
  // Chuyển đổi từ số `yyyymmdd` thành đối tượng `Date`
  const str = dateInt.toString()
  const year = parseInt(str.substring(0, 4), 10)
  const month = parseInt(str.substring(4, 6), 10) - 1 // Tháng tính từ 0
  const day = parseInt(str.substring(6, 8), 10)
  const date = new Date(year, month, day)

  // Lấy ngày đầu tiên của năm
  const startOfYear = new Date(year, 0, 1)

  // Tính số ngày đã trôi qua trong năm
  const pastDays = Math.floor((date - startOfYear) / (24 * 60 * 60 * 1000))

  // Tính số tuần, cộng 1 để bắt đầu từ tuần 1
  return Math.ceil((pastDays + startOfYear.getDay() + 1) / 7)
}

/**
 *
 * @param {Number} dateInt - định dạnh yyyymmdd
 * @returns {Date} - trả về Date()
 */
export function convertDateIntToDate (dateInt) {
  const year = parseInt(dateInt.substring(0, 4), 10)
  const month = parseInt(dateInt.substring(4, 6), 10) - 1 // Month is 0-based
  const day = parseInt(dateInt.substring(6, 8), 10)

  return new Date(year, month, day)
}

function formatDate (date) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0') // Tháng bắt đầu từ 0
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}${month}${day}`
}

export function getStartAndEndOfWeek (date = new Date()) {
  const day = date.getDay() // Lấy thứ trong tuần (0 = Chủ nhật, 1 = Thứ 2, ..., 6 = Thứ 7)
  const diffToMonday = (day === 0 ? -6 : 1) - day // Điều chỉnh nếu là Chủ nhật
  const startOfWeek = new Date(date)
  startOfWeek.setDate(date.getDate() + diffToMonday)
  startOfWeek.setHours(0, 0, 0, 0) // Đặt giờ về 00:00:00

  const endOfWeek = new Date(startOfWeek)
  endOfWeek.setDate(startOfWeek.getDate() + 6)
  endOfWeek.setHours(23, 59, 59, 999) // Đặt giờ về 23:59:59

  return {
    startOfWeek: formatDate(startOfWeek),
    endOfWeek: formatDate(endOfWeek)
  }
}

// Output: 20250201
export function getStartOfMonth (date = new Date()) {
  const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1)
  startOfMonth.setHours(0, 0, 0, 0)
  return formatDate(startOfMonth)
}

// lấy số ngày chủ nhật từ startDate đến endDate
export function countSundaysAndTotalDays (startDate, endDate) {
  // Chuyển đổi chuỗi YYYYMMDD thành đối tượng Date
  function parseDate (yyyymmdd) {
    const year = parseInt(yyyymmdd.substring(0, 4), 10)
    const month = parseInt(yyyymmdd.substring(4, 6), 10) - 1
    const day = parseInt(yyyymmdd.substring(6, 8), 10)
    return new Date(year, month, day)
  }

  const start = parseDate(startDate)
  const end = parseDate(endDate)
  let countSundays = 0

  // Tính tổng số ngày
  const totalDays = Math.floor((end - start) / (24 * 60 * 60 * 1000)) + 1

  while (start <= end) {
    if (start.getDay() === 0) {
      countSundays++
    }
    start.setDate(start.getDate() + 1)
  }

  return { countSundays, totalDays }
}

function convertIntToDate (dateInt) {
  const dateString = dateInt.toString()
  const year = parseInt(dateString.slice(0, 4), 10)
  const month = parseInt(dateString.slice(4, 6), 10) - 1 // Tháng trong JavaScript bắt đầu từ 0
  const day = parseInt(dateString.slice(6, 8), 10)

  return new Date(year, month, day)
}

export function getDateBetween (startDate, endDate) {
  const start = convertIntToDate(startDate)
  const end = convertIntToDate(endDate)

  if (start > end) {
    throw new Error('startDate phải nhỏ hơn hoặc bằng endDate')
  }

  const dates = []
  const currentDate = new Date(start)

  while (currentDate <= end) {
    dates.push(formatDate(currentDate))
    currentDate.setDate(currentDate.getDate() + 1)
  }

  return dates
}

/**
 *
 * @param {Number} year - định dạnh yyyy
 * @returns {Array<String>} - trả về List<String> = [yyyyMM]
 */
export function getYearMonthNumberOptions (year) {
  return Array.from({ length: 12 }, (_, i) => `${year}${(i + 1).toString().padStart(2, '0')}`)
}

export function getYearMonthOptions (year) {
  const yearMonths = getYearMonthNumberOptions(year)
  return yearMonths.map(yearMonth => (
    {
      value: yearMonth,
      label: formatYearMonth(yearMonth)
    }
  ))
}

export function getYearMonthOptionByYearMonth (yearMonth) {
  return (
    {
      value: yearMonth,
      label: formatYearMonth(yearMonth)
    }
  )
}

/**
 *
 * @returns {Array<String>} - trả về List<String> = [MM/yyyy]
 * @param yyyymm
 */
export function formatYearMonth (yyyymm) {
  if (!yyyymm) return
  const str = yyyymm.toString()
  const year = str.substring(0, 4)
  const month = str.substring(4, 6)

  return `${month}/${year}`
}

export function convertDateToDDMMYYYY (yyyymmdd) {
  const str = String(yyyymmdd)
  const year = str.substring(0, 4)
  const month = str.substring(4, 6)
  const day = str.substring(6, 8)

  return `${day}/${month}/${year}`
}

export function formatDateDDMMYYYY (date) {
  if (!date) return ''
  const [yyyy, mm, dd] = date.split('-')
  return `${dd}/${mm}/${yyyy}`
}

export function formatDateDDMM(date) {
  if (!date) return '';
  const [yyyy, mm, dd] = date.split('-');
  return `${dd}/${mm}`;
}

/**
 * Tính hạn giữ lịch: 2 ngày từ ngày hiện tại, nếu có Chủ nhật thì thành 3 ngày
 * @param {string|Date} [startDate] - Ngày bắt đầu (mặc định là ngày hiện tại)
 * @returns {string} - Chuỗi định dạng "00h00 - DD/MM/YYYY"
 */
export function calculateBookingLimit (startDate) {
  // Nếu không truyền startDate, dùng ngày hiện tại theo UTC+7
  const currentDate = startDate ? moment(startDate).utcOffset(7 * 60) : moment().utcOffset(7 * 60)

  // Tính ngày hạn ban đầu: cộng 2 ngày
  let limitDate = currentDate.clone().add(2, 'days')

  // Kiểm tra xem trong khoảng từ currentDate đến limitDate có Chủ nhật không
  let hasSunday = false
  for (let i = 0; i <= 2; i++) {
    if (currentDate.clone().add(i, 'days').day() === 0) { // 0 là Chủ nhật
      hasSunday = true
      break
    }
  }

  // Nếu có Chủ nhật, cập nhật hạn thành 3 ngày
  if (hasSunday) {
    limitDate = currentDate.clone().add(3, 'days')
  }

  // Trả về chuỗi định dạng
  return `00h00 - ${limitDate.format('DD/MM/YYYY')}`
}

/**
 * Tính toán năm và tháng mới sau khi cộng/trừ offset
 - Ví dụ: year = 2023, month = 3, offset = -1 --> Kết quả trả về sẽ là: { year: 2023, month: 2 }
 - Ví dụ: year = 2023, month = 1, offset = -1 --> Kết quả trả về sẽ là: { year: 2022, month: 12 }
 - Ví dụ: year = 2023, month = 12, offset = 1 --> Kết quả trả về sẽ là: { year: 2024, month: 1 }
 * @param year
 * @param month
 * @param offset
 * @returns {{year, month: *}}
 */
export function calcOffset (year, month, offset) {
  let newMonth = month + offset
  let newYear = year

  // Điều chỉnh năm/tháng khi vượt ngoài 1-12
  while (newMonth <= 0) {
    newMonth += 12
    newYear -= 1
  }
  while (newMonth > 12) {
    newMonth -= 12
    newYear += 1
  }

  return { year: newYear, month: newMonth }
}

/**
 * Lấy khoảng thời gian từ ngày đầu tiên của tháng offsetStart đến ngày cuối cùng của tháng offsetEnd
 - Ví dụ: createdAt = 15/03/2023, offsetStart = -1, offsetEnd = 1
 --> Kết quả trả về sẽ là: { firstDay: 00:00:00 01/02/2023, lastDay: 23:59:59 31/04/2023 }
 * @param createdAt
 * @param offsetStart
 * @param offsetEnd
 * @returns {{firstDay: number, lastDay: number}}
 */
export function getMonthRange (createdAt, offsetStart, offsetEnd) {
  const baseDate = new Date(createdAt)
  const baseYear = baseDate.getFullYear()
  const baseMonth = baseDate.getMonth() + 1 // 1-12

  // Tính tháng/năm cho offsetStart và offsetEnd
  const { year: startYear, month: startMonth } = calcOffset(baseYear, baseMonth, offsetStart)
  const { year: endYear, month: endMonth } = calcOffset(baseYear, baseMonth, offsetEnd)

  // Ngày đầu tiên của offsetStart
  const firstDay = new Date(startYear, startMonth - 1, 1, 0, 0, 0, 0).getTime()

  // Ngày cuối cùng của offsetEnd
  const lastDay = new Date(endYear, endMonth, 1, 23, 59, 59, 999)
  lastDay.setMonth(endMonth)
  lastDay.setDate(0)
  const lastDayTs = lastDay.getTime()

  return { firstDay, lastDay: lastDayTs }
}

/**
 * Định dạng ngày giờ theo format truyền vào
 - Sử dụng thư viện momentjs
 - Xem chi tiết các format tại: https://momentjs.com/docs/#/displaying/format/
 - Mặc định format là 'DD/MM/YYYY HH:mm:ss'
 - Ví dụ: timestamp = 1678901234567, format = 'DD/MM/YYYY HH:mm:ss' --> Kết quả trả về sẽ là: '15/03/2023 10:33:54'
 - Ví dụ: timestamp = 1678901234567, format = 'HH:mm DD/MM/YYYY' --> Kết quả trả về sẽ là: '10:33 15/03/2023'
 * @param timestamp
 * @param format
 * @returns {string}
 */
export function formatDateTime (timestamp, format = 'DD/MM/YYYY HH:mm:ss') {
  return moment(timestamp).format(format)
}

export function timeToSeconds (time) {
  if (!time) return 0
  const [hours, minutes] = time.split(':').map(Number)
  return hours * 60 + minutes
}

export function getMonthNow () {
  const now = new Date()
  const month = (now.getMonth() + 1).toString().padStart(2, '0')
  const year = now.getFullYear()
  return `${month}/${year}`
}

/**
 * Lấy định dạng tuần từ ngày học (learnDate)
 * Tuần tính từ thứ 2 đến chủ nhật
 * @param {Number} learnDate - định dạng yyyyMMdd, ví dụ: 20260318
 * @returns {String} - Chuỗi định dạng "tuần dd/mm - dd/mm/yyyy", ví dụ: "tuần 16/03 - 22/03/2026"
 */
export function formatWeekDisplay (learnDate) {
  if (!learnDate) return ''

  // Chuyển đổi từ yyyyMMdd thành moment object
  const dateMoment = moment(learnDate.toString(), 'YYYYMMDD')

  // Lấy ngày bắt đầu tuần (thứ 2 - Monday)
  // Tính offset từ ngày hiện tại đến thứ 2 tuần này
  const dayOfWeek = dateMoment.day() // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
  const diffToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek
  const mondayOfWeek = dateMoment.clone().add(diffToMonday, 'days')

  // Lấy ngày kết thúc tuần (chủ nhật - Sunday)
  const sundayOfWeek = mondayOfWeek.clone().add(6, 'days')

  // Format ngày thứ 2 thành dd/mm
  const mondayFormatted = mondayOfWeek.format('DD/MM')

  // Format ngày chủ nhật thành dd/MM/YYYY
  const sundayFormatted = sundayOfWeek.format('DD/MM/YYYY')

  return `${mondayFormatted} - ${sundayFormatted}`
}

export function getWeekFromLearnDate (learnDate) {
  if (!learnDate) return ''

  // Chuyển đổi từ yyyyMMdd thành moment object
  const dateMoment = moment(learnDate.toString(), 'YYYYMMDD')

  // Lấy ngày bắt đầu tuần (thứ 2 - Monday)
  // Tính offset từ ngày hiện tại đến thứ 2 tuần này
  const dayOfWeek = dateMoment.day() // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
  const diffToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek
  const mondayOfWeek = dateMoment.clone().add(diffToMonday, 'days')

  // Lấy ngày kết thúc tuần (chủ nhật - Sunday)
  const sundayOfWeek = mondayOfWeek.clone().add(6, 'days')

  return {
    mondayOfWeek: mondayOfWeek.format('YYYYMMDD'),
    sundayOfWeek: sundayOfWeek.format('YYYYMMDD')
  }
}
